import React from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../../common/hooks/hooks";
import { closeMultiPanelOffcanvas } from "../../../../../common/features/multiPanelOffcanvas/multiPanelOffcanvasSlice";
import { useFeaturedContent } from "../../hooks/useFeaturedContent";
import ProductPanelItem from "../../../product/components/common/ProductPanelItem/ProductPanelItem";
import ProductPanelItemSkeleton from "../../../product/components/common/ProductPanelItem/ProductPanelItemSkeleton";
import Skeleton from "react-loading-skeleton";

const PanelFeaturedProducts: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { products, isLoading } = useFeaturedContent();

  const handleItemClick = () => {
    dispatch(closeMultiPanelOffcanvas());
  };

  // Loading Skeleton
  if (isLoading) {
    return (
      <div className="panel-featured-products">
        <h3 className="panel-featured-products__title">
          <Skeleton width={150} />
        </h3>
        <ul className="panel-featured-products__list">
          {Array.from({ length: 2 }).map((_, i) => (
            <ProductPanelItemSkeleton key={i} />
          ))}
        </ul>
      </div>
    );
  }

  if (products.length === 0) {
    return null;
  }

  const title = t("featuredContent.productsTitle", "Featured Products");

  return (
    <div className="panel-featured-products">
      <h3 className="panel-featured-products__title">{title}</h3>
      <ul className="panel-featured-products__list">
        {products.map((product) => (
          <ProductPanelItem
            key={product.id}
            product={product}
            onItemClick={handleItemClick}
            showStockStatus={false}
          />
        ))}
      </ul>
    </div>
  );
};

export default PanelFeaturedProducts;
